import React, { FC, ReactNode } from 'react'

import styled from 'styled-components'

import { WithClassName, WithDataName } from 'common/types'
import { FontSize } from 'common-constants/sizes'

export const Badge: FC<
  {
    icon: ReactNode
    text: ReactNode
  } & WithClassName &
    WithDataName
> = ({ className, icon, text, ...rest }) => {
  const dataName = rest['data-name'] ? rest['data-name'] : null

  return (
    <BadgeInner className={className} data-name={dataName}>
      {icon}
      <Text>{text}</Text>
    </BadgeInner>
  )
}

const BadgeInner = styled.div`
  display: flex;
  align-items: center;
  border-radius: 20px;
  font-size: ${FontSize.nano}px;
  text-transform: uppercase;
  font-weight: bold;
  padding: 4px;
  max-width: fit-content;
  overflow: hidden;
  letter-spacing: 0.5px;
  line-height: 7px;
`

const Text = styled.div`
  margin-top: 0.5px; /* Текст рендерится чуть выше, чем должен */
  ${({ theme }) => theme.marginLeft}: 4px;
`
